import * as firebase from 'firebase/app';
import 'firebase/firestore';
import { toDateFormat } from 'utils/helpers/timestampHelper';
import { NOTES } from 'utils/constants/collectionNames';
import {
  GET_NOTES_SUCCEED,
  GET_NOTES_ERROR,
  GET_NOTE_SUCCEED,
  GET_NOTE_ERROR,
  DELETE_NOTE_SUCCEED,
  DELETE_NOTE_ERROR,
  EDIT_NOTE_SUCCEED,
  EDIT_NOTE_ERROR,
  CREATE_NOTE_SUCCEED,
  CREATE_NOTE_ERROR,
  LOADING_STATE
} from './types';

export const getNotes = (trainerId, clientId) => async dispatch => {
  try {
    dispatch({
      type: LOADING_STATE
    });
    let firestore = firebase.firestore();
    let queryRef = firestore
      .collection(NOTES)
      .where('client_id', '==', clientId)
      .where('trainer_id', '==', trainerId)
      .orderBy('created_at', 'desc');
    return queryRef.onSnapshot(querySnapshot => {
      const notes =
        querySnapshot.docs &&
        querySnapshot.docs.map(doc => {
          let note = { ...doc.data() };
          note.created_at = toDateFormat(note.created_at);
          return {
            ...note,
            id: doc.id
          };
        });
      dispatch({ type: GET_NOTES_SUCCEED, payload: notes });
    });
  } catch (err) {
    console.log(err);
    dispatch({
      type: GET_NOTES_ERROR,
      payload: `error: ${err}`
    });
  }
};

export const getNote = (noteId, history) => async dispatch => {
  dispatch({
    type: LOADING_STATE
  });

  let firestore = firebase.firestore();
  let docRef = firestore.collection(NOTES).doc(noteId);
  docRef
    .get()
    .then(function(doc) {
      if (doc.exists) {
        dispatch({
          type: GET_NOTE_SUCCEED,
          payload: {
            ...doc.data(),
            id: doc.id
          }
        });
      } else {
        console.log('This Note is not exist!');
        history.replace('/event-not-found');
      }
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: GET_NOTE_ERROR,
        payload: `error: ${error}`
      });
      history.replace('/event-not-found');
    });
};

export const deleteNote = noteId => async dispatch => {
  let db = firebase.firestore();
  db.collection(NOTES)
    .doc(noteId)
    .delete()
    .then(function() {
      dispatch({ type: DELETE_NOTE_SUCCEED });
      console.log('Document successfully deleted!');
    })
    .catch(function(error) {
      console.error('Error removing document: ', error);
      dispatch({
        type: DELETE_NOTE_ERROR,
        payload: `error: ${error}`
      });
    });
};

export const editNote = note => async dispatch => {
  let firestore = firebase.firestore();
  var docRef = firestore.collection(NOTES).doc(note.id);

  return docRef
    .set({ text: note.text }, { merge: true })
    .then(function() {
      return dispatch({
        type: EDIT_NOTE_SUCCEED
      });
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: EDIT_NOTE_ERROR,
        payload: `error: ${error}`
      });
    });
};

export const addNote = note => async dispatch => {
  var trainer = await firebase.auth().currentUser;
  let newNote = {
    ...note,
    created_at: new Date(),
    trainer_id: trainer.uid,
    trainer_name: trainer.displayName,
    trainer_photo: trainer.photoURL
  };
  let firestore = firebase.firestore();
  firestore
    .collection(NOTES)
    .add({ ...newNote })
    .then(function(docRef) {
      dispatch({
        type: CREATE_NOTE_SUCCEED,
        payload: docRef.id
      });
    })
    .catch(function(error) {
      console.error('Error adding document: ', error);
      dispatch({
        type: CREATE_NOTE_ERROR,
        payload: `error: ${error}`
      });
    });
};
